<mat-toolbar *ngIf="showToolbar">
  <!-- <button *ngIf="!drawerRefer.opened" style="border: 0px; margin-right: 0.5rem; background-color: transparent">

  </button> -->
  <img src="../assets/icons/menu.svg" class="menu-icon" width="28" alt="111" (click)="toggleDrawer()" />
</mat-toolbar>
<!--  <mat-progress-bar *ngIf="true" mode="indeterminate"></mat-progress-bar>-->
